import styled from 'styled-components';
import theme from '../../theme';


export const OptionsScrollContainer = styled.div`
  position: relative;
  width: 100%;
  height: calc(var(--vh, 1vh) * 35);
  margin-bottom: calc(var(--vh, 1vh) * 18);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  /* Hide scrollbar but keep functionality */
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }



  @media (max-height: 550px) {
    height: calc(var(--vh, 1vh) * 40);
  }
`;

export const OptionsContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

`;

export const OptionButton = styled.button`
  width: 100%;
  height: calc(var(--vh, 1vh) * 10);
  max-height: 60px;
  min-height: 50px;
  border-radius: 20px;
  background: ${props => props.isSelected ? '#FFFFFF' : theme.colors.background_fonce};
  border: 1px solid ${props => props.isSelected ? theme.colors.gris : 'transparent'};
  color: ${theme.colors.noir};
  font-family: ${theme.fonts.main};
  font-size: ${theme.fontSizes.large};
  font-weight: ${theme.fontWeights.medium};
  cursor: pointer;
  transition: all 0.3s ease;
  -webkit-tap-highlight-color: transparent;
  text-align: left;
  padding-left: ${theme.spacing.large};

  /* Prevent text selection */
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  /* Add subtle scale animation when selected */
  ${props => props.isSelected && `
    animation: selectPulse 0.3s ease-out;

    @keyframes selectPulse {
      0% { transform: scale(1); }
      50% { transform: scale(1.02); }
      100% { transform: scale(1); }
    }
  `}

  /* Disable hover effects when selected */
  ${props => props.isSelected && `
    &:hover {
      transform: none;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
  `}

  /* Adjust for smaller screens */
  @media (max-height: 550px) {
    height: calc(var(--vh, 1vh) * 10);
    min-height: 40px;
    font-size: ${theme.fontSizes.medium};
    padding: ${theme.spacing.small} ${theme.spacing.medium};
  }
`;

export const ButtonsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: calc(var(--vh, 1vh) * 3);
  opacity: 0;
  transform: translateY(20px);
  animation: fadeIn 0.5s ease forwards;

  @keyframes fadeIn {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-height: 550px) {
    gap: calc(var(--vh, 1vh) * 2);
  }
`;

export const ErrorMessage = styled.div`
  color: ${theme.colors.error};
  text-align: center;
  margin: calc(var(--vh, 1vh) * 2) 0;
  font-size: ${theme.fontSizes.small};
  min-height: calc(var(--vh, 1vh) * 3);
  opacity: 0;
  animation: fadeIn 0.3s ease forwards;
`;

export const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(var(--vh, 1vh) * 100);
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  opacity: 0;
  pointer-events: ${props => props.isLoading ? 'auto' : 'none'};
  transition: opacity 0.3s ease;
  ${props => props.isLoading && 'opacity: 1;'}
`;